import { Tooltip } from "antd";
import { AlertCircle } from "react-feather";
import { useCpFormAnyValue, useCpFormErrorWarning } from "./utils";

interface Props {
  names: string[];
}

export function CpErrorWarningArrayIcon({ names }: Props) {
  const submitted = useCpFormAnyValue(`meta.submitted`);
  const res = useCpFormErrorWarning(names);

  if (res.error && submitted) {
    return (
      <Tooltip title={res.error}>
        <AlertCircle size={16} className={`inline ml-2 color-danger`} />
      </Tooltip>
    );
  }

  if (res.warning) {
    return (
      <Tooltip title={res.warning}>
        <AlertCircle size={16} className={`inline ml-2 color-warning`} />
      </Tooltip>
    );
  }

  return null;
}

interface Props2 {
  names: string[];
}
export function CpErrorWarningArrayIconLink({ names }: Props2) {
  const res = useCpFormErrorWarning(names || []);
  const submitted = useCpFormAnyValue(`meta.submitted`);

  if (!res.error && !res.warning) {
    return null;
  }

  if (res.error && submitted) {
    return (
      <Tooltip title={res.error}>
        <span className="absolute right-0 top-0 bottom-0 flex items-center justify-center pr-2 z-10">
          <AlertCircle size={18} className={`color-danger`} />
        </span>
      </Tooltip>
    );
  }

  if (res.warning) {
    return (
      <Tooltip title={res.warning}>
        <span className="absolute right-0 top-0 bottom-0 flex items-center justify-center pr-2 z-10">
          <AlertCircle size={18} className={`color-warning`} />
        </span>
      </Tooltip>
    );
  }

  return null;
}
